import React from 'react'
import globals from '../globals'
import { connect } from 'react-redux'
import Notifications from '../modules/Notifications'
import MyServicesList from '../modules/MyServicesList'
import ManageServices from '../modules/ManageServices'
import DataSource, { postTokenExchange, getCustomerDetailsXAPI } from '../DataSource'
import PendingConnections from '../modules/PendingConnections'
import TelstraMigrateBanner from '../modules/TelstraMigrateBanner'
import ExetelAFriendBanner from '../components/ExetelAFriendBanner'
import FasterNbnBoosterBanner from '../components/FasterNbnBoosterBanner'
import FlipToFibreBanner from '../modules/FlipToFibreBanner'
import {getCustomer, setExchangeToken} from "../redux/actions"
import MoveToOnePlanBanner from '../modules/MoveToOnePlan/MoveToOnePlanBanner'

class MyServices extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
		    isLoaded: false,
            hasError: false,
            notifications: [],
            broadband: [],
            mobile: [],
            phone: [],
            isNbnReady: false,
            hasOptusService: false,
            isFlipReady: false,
            hasSpeedBoost: false,
            isMoveToOnePlanEligible: false,
        }
    }

    componentDidMount () {
        globals.animatePageIn(this.container)
        if (!this.props.customerId && this.props.isLoggedIn) {
            this.props.getCustomer()
        }
        this.getServiceData().then()
        console.info("My service component.....")
        this.getExchangeToken()
    }

    componentDidUpdate(prevProps) {
        
        if ( this.props.exchangeToken &&
            this.props.exchangeToken !== prevProps.exchangeToken) {
            console.log("Component update:", this.props.exchangeToken);
            this.fetchCustomerDetails()
        }
    }

    isOnePlanUpgradeEligible(response) {
        const svcList = response && response.data && response.data.services;
        if (!Array.isArray(svcList) || svcList.length === 0) {
          return false;
        }
        svcList.forEach((item) => {
          return  item.offer && item.offer.features && item.offer.features.onePlanUpgradeEligibility
        })
        
        return false
      }

    async fetchCustomerDetails() {
        console.info("props in fetch customer::", this.props)
        try {
            const response = await getCustomerDetailsXAPI(this.props.customerId, this.props.exchangeToken);
            console.log("Customer details:", response);
            if (response && response.data) {
                this.setState({
                    isMoveToOnePlanEligible: this.isOnePlanUpgradeEligible(response)
                })
            }
        } catch (error) {
            console.error("Error fetching customer details:", error)
        }
    }

    async getServiceData () {
        console.info("props in getservice::", this.props)
        await DataSource.getData(`/api/getServices/${this.props.customerId}`, result => {
            this.setState({
                ...result,
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    async getExchangeToken() {
        console.info("props in exchange::", this.props)
        if (this.props.email) {
            const response = await postTokenExchange(this.props.email)
            console.info("Token exchange...", response)
            if (response && response.data) this.props.setExchangeToken(response.data.access_token)
        }
    }

    handleHideFlipToFibreBanner () {
        this.setState({ isFlipReady: false });
    }

    render () {
        return <div ref={el => (this.container = el)} style={{ opacity: 0 }}>
            {this.state.notifications.length > 0 ? <Notifications icon="icon-notification.svg">
                {this.state.notifications.map((item, key) => {
                    return <p key={key} className={key > 0 ? "mt-3 mt-md-1" : ""}>
                        {item}
                    </p>;
                })}
            </Notifications> : ""}
            {this.state.isFlipReady ? <FlipToFibreBanner services={this.state.broadband} handleHideFlipToFibreBanner={this.handleHideFlipToFibreBanner.bind(this)} /> : ""}
            {this.state.hasOptusService && !this.state.isFlipReady ? <TelstraMigrateBanner /> : ""}
            {this.state.isMoveToOnePlanEligible && <MoveToOnePlanBanner />}
            <PendingConnections />
            <MyServicesList broadband={this.state.broadband} mobile={this.state.mobile} phone={this.state.phone} hasError={this.state.hasError} isLoaded={this.state.isLoaded} />
            {this.state.hasSpeedBoost && !this.state.isFlipReady ? <FasterNbnBoosterBanner /> : ""}
            {/* {this.props.residential ? <ExetelAFriendBanner /> : ''} */}
            {this.state.broadband.length > 0 || this.state.mobile.length > 0 ? <ManageServices /> : ""}
        </div>;
    }
}

const mapStateToProps = state => ({
    customerId: state.auth.id,
    email: state.auth.contactEmail,
    residential: state.auth.residential,
    isLoggedIn: state.auth.isLoggedIn,
    exchangeToken: state.auth.exchangeToken
})

export default connect(mapStateToProps, {getCustomer, setExchangeToken})(MyServices)



// WEBPACK FOOTER //
// ./resources/js/pages/MyServices.js